/**
 * The page the app opens on: `/hq/`, sign-in, signup's end, an invite's join
 * and every unknown path land here. Today, home again (slice 4b spec §6).
 */
export const HOME = "/today";
